import { render, staticRenderFns } from "./EnviarBase.vue?vue&type=template&id=c7f24ef0"
import script from "./EnviarBase.vue?vue&type=script&lang=js"
export * from "./EnviarBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports